import React from 'react';
import '../../scss/controls/_filechooser.scss';

export const FileChooser: React.FC<{
    id: string;
    dataTestid: string;
    handleChange: React.ChangeEventHandler<HTMLInputElement>;
    labeledBy?: string;
    acceptableFileTypes?: string;
    required?: boolean;
}> = ({ id, dataTestid, handleChange, labeledBy, acceptableFileTypes, required }) => {
    return (
        <>
            <input
                type='file'
                id={id}
                data-testid={dataTestid}
                onChange={handleChange}
                className='fileChooser-picker'
                aria-labelledby={labeledBy}
                accept={acceptableFileTypes}
                required={required}
                aria-required={required}
            />
        </>
    );
};
